// extracted by mini-css-extract-plugin
module.exports = {"lang":"lG","langWrap":"lH","item":"lI","itemCurrent":"lJ"};